import moment from 'moment'

export const formatDateTime = (date) => {
  return moment(date).format('MMMM Do YYYY, h:mm:ss a')
}

// ERP audit timestamps are the ERP's zoneless wall-clock time stored as UTC; format in
// UTC so they aren't shifted into the browser's zone (10/8 00:00 reading as 10/7 7pm).
export const formatAuditDateTime = (date) => {
  return moment.utc(date).format('MMMM Do YYYY, h:mm:ss a')
}

export const formatDate = (date) => {
  return moment(date).format('MMM Do YYYY')
}

export const formatDateSlash = (date) => {
  if (!date) return ''
  // Date-semantic values are serialized as UTC midnight (e.g. "2025-09-11T00:00:00.000Z").
  // Format in UTC so the displayed calendar date matches what's stored and what the
  // exact-date filter targets; moment(value) renders in the browser's local zone and
  // shifts the date back a day in US timezones.
  return moment.utc(date).format('MM/DD/YYYY')
}

export const formatShortDate = (date) => {
  return moment(date).format('MMM Do, YY')
}

export const formatDateParam = (date) => {
   return (date ? new Date(date).toISOString() : '')
}

export const datetimeAscending = (dates) => {
  return dates.sort((a, b) => a.date.localeCompare(b.date))
}

export const jsDateToSlash = (date) => {
  const month = date.getMonth() + 1
  const day = date.getDate()
  const year = date.getFullYear()
  return month + '/' + day + '/' + year
}

// Parse date string as local time and format using toLocaleDateString()
// Without the T00:00:00 suffix, "2025-07-30" is parsed as UTC midnight,
// which displays as the previous day in US timezones
export const formatDateLocal = (date) => {
  if (!date) return 'N/A'
  // If it's a date-only string (e.g. "2025-07-18"), append T00:00:00 to
  // avoid UTC midnight being displayed as the previous day in US timezones.
  // Full datetime strings (e.g. ISO with "T" or "Z") are parsed as-is.
  const dateStr = String(date)
  const parsed = dateStr.includes('T') || dateStr.includes('Z')
    ? new Date(dateStr)
    : new Date(dateStr + 'T00:00:00')
  return parsed.toLocaleDateString()
}

export const generateRelativeMonths = () => {
  // Array to hold month names
  const monthNamesLong = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  const monthNamesShort = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]

  // Get current date
  const currentDate = new Date()
  let currentMonth = currentDate.getMonth() // Note: January is 0, February is 1, and so on.
  let currentYear = currentDate.getFullYear()

  // Array to store month data
  let monthsArray = []

  // Generate data for the previous 12 months
  for (let i = 0; i < 12; i++) {
    // Insert at the beginning to maintain chronological order
    monthsArray.unshift({
      month_short: monthNamesShort[currentMonth],
      month_long: monthNamesLong[currentMonth],
      year: currentYear.toString()
    })

    // Move to the previous month, adjust year if needed
    currentMonth--
    if (currentMonth < 0) {
      // Adjust for indexing (January is 0)
      currentMonth = 11 // Reset to December
      currentYear-- // Move to the previous year
    }
  }

  return monthsArray
}
